export const TYPE_ORDER = ['A', 'B', 'C', 'D', 'E', 'P']

export const DIR_REASON = 'Deceased/Inactive/Retired'
export const DIR_SUB_REASONS = ['Deceased', 'Inactive', 'Retired']
export const MOT_REASON = 'Moved Out of Territory'

export function getFinalType(row) {
    return row.TARGET_TYPE || row.CHANGED_TARGET_VALUE || row.CURRENT_TARGET_VALUE
}

/** Returns true when a row has been marked DIR (Deceased/Inactive/Retired). */
export function isDIR(row) {
    return (
        (!row.TARGET_TYPE || row.TARGET_TYPE === 'NT') &&
        (row.REASON === DIR_REASON || DIR_SUB_REASONS.includes(row.REASON))
    )
}

/** Returns true when a row has been marked MOT (Moved Out of Territory). */
export function isMOT(row) {
    return row.REASON === MOT_REASON
}

export function resolvePrevType(row, prevCol, fallbackCol = null) {
    return row[prevCol] || (fallbackCol ? row[fallbackCol] : undefined)
}

export function deriveRowStatus(row, prevCol = 'PREV_TARGET_TYPE', fallbackCol = null) {
    // DIR is always treated as dropped — the HCP is being removed from targeting
    // regardless of whether they had a previous type (existing) or were newly added (prev=NT)
    if (isDIR(row)) return 'dropped'
    const prevType = resolvePrevType(row, prevCol, fallbackCol)
    const finalType = getFinalType(row)
    if (!finalType || finalType === 'NT') return (!prevType || prevType === 'NT') ? 'unchanged' : 'dropped'
    if (!prevType || prevType === 'NT') return 'added'
    if (prevType === finalType) return 'unchanged'
    return TYPE_ORDER.indexOf(finalType) < TYPE_ORDER.indexOf(prevType) ? 'promoted' : 'demoted'
}
